module.exports = __webpack_public_path__ + "img/Rebuildables.66bba550.jpg";